<template>
  <div class="col-12 d-flex align-items-center h-100 p-5">
    <div class="dot-opacity-loader">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style></style>
